import type { LandingTranslations } from './pt-BR';

const esUY: LandingTranslations = {
  // ── Configuración de moneda / locale
  currency: {
    symbol: '$',
    code: 'USD',
    locale: 'es-UY',
  },

  // ── Navbar
  nav: {
    home: 'Inicio',
    chaos: 'Caos en la Portería',
    howItWorks: 'Cómo funciona',
    product: 'Producto',
    modules: 'Módulos',
    plans: 'Planes',
    faq: 'Preguntas',
    login: 'Ingresar',
    trialBtn: 'Prueba gratis',
  },

  // ── Hero slides
  hero: {
    slides: [
      {
        badge: '⚡ Tan simple como WhatsApp',
        h2Line1: 'Si usa WhatsApp,',
        h2Line2: 'ya sabe usar',
        h2Accent: 'CondoClick',
        p: 'Sin cursos, sin manuales, sin técnicos. Si el portero usa WhatsApp en el día a día, ya domina el sistema. Cero capacitación compleja — configuración en 2 minutos y el primer registro hecho hoy mismo.',
      },
      {
        badge: 'Paquetes Digitales — sin papel, sin pérdidas',
        h2Line1: 'De la portería al vecino,',
        h2Line2: 'cada entrega rastreada,',
        h2Accent: 'cero paquete perdido',
        p: 'El portero fotografía y registra. El residente recibe aviso en WhatsApp con foto. El retiro se confirma por QR Code. Todo rastreado, sin papel, sin llamadas.',
      },
      {
        badge: 'Gestión de Portería — todo bajo control',
        h2Line1: 'Incidencias, comunicados',
        h2Line2: 'y checklists al día,',
        h2Accent: 'todo en un solo lugar',
        p: 'Equipo alineado, administrador informado y vecinos satisfechos. Informes completos y transparencia total sin ningún papel.',
      },
      {
        badge: 'Ingreso de Vehículos — acceso inteligente',
        h2Line1: 'Registre patentes, autorice',
        h2Line2: 'visitantes desde el celular,',
        h2Accent: 'sin filas en la portería',
        p: 'Registro de visitantes y autorización desde la app. Portería más ágil, seguridad reforzada e historial completo de todos los ingresos.',
      },
      {
        badge: '😅 Sin CondoClick — la portería es un caos',
        h2Line1: 'Planillas, cuadernos,',
        h2Line2: 'WhatsApp y gritos…',
        h2Accent: '¡hay una mejor manera! 🚀',
        p: 'Administrador, lo sabemos: sin sistema, el control de acceso se vuelve un caos. Visitante sin autorización, vecino llamando a portería a las 23h y planillas desactualizadas. Con CondoClick, eso es pasado.',
      },
      {
        badge: '⚡ Tan simple como WhatsApp',
        h2Line1: 'Si usa WhatsApp,',
        h2Line2: 'ya sabe usar',
        h2Accent: 'CondoClick',
        p: 'Sin cursos, sin manuales, sin técnicos. Si el portero usa WhatsApp en el día a día, ya domina el sistema. Cero capacitación compleja — configuración en 2 minutos y el primer registro hecho hoy mismo.',
      },
    ],
    cta: 'Suscribirse ahora — desde {{symbol}} 49/mes',
    trustNoFidelity: 'Sin permanencia',
    trustCancel: 'Cancele cuando quiera',
    trustSupport: 'Soporte incluido',
  },

  // ── Social proof bar
  stats: {
    condos: 'condominios activos',
    syndics: 'administradores satisfechos',
    setup: 'tiempo de configuración',
  },

  // ── Sección DOLORES
  pain: {
    sectionBadge: 'Realidad del 89% de las porterías de la región',
    title: 'La portería se volvió el problema',
    titleAccent: 'más difícil del condominio',
    subtitle: 'Portero sobrecargado, vecino irritado, administrador apagando incendios — y al final del día no hay registro de nada. Y como si fuera poco, llegó la LGPD: cuadernos, planillas y softwares obsoletos no protegen los datos de nadie. Quien no se adecúe puede enfrentar multas de hasta R$ 50 millones — y expone a cada vecino.',
    stats: [
      { n: '340h', label: 'por año perdidas en llamadas innecesarias (por portero)' },
      { n: '25%', label: 'de los paquetes quedan más de 7 días sin retirar' },
      { n: '73%', label: 'de los conflictos en condominios comienzan en la portería' },
      { n: '$ 0', label: 'de rastro o prueba cuando algo sale mal' },
    ],
    detailTitle: 'Los 7 grandes problemas',
    detailSubtitle: 'Cada día en la portería es una nueva batalla',
    detailDesc: 'Mapeamos los problemas más frecuentes reportados por porteros, administradores y vecinos en cientos de condominios de la región.',
    voices: {
      sectionLabel: 'Quien lo vive todos los días',
      title: 'La voz de quien está en la portería',
      subtitle: 'Relatos reales recolectados durante investigación con porteros y administradores en toda la región.',
      items: [
        {
          quote: 'Vivo al teléfono. Mientras hablo con un vecino que quiere saber si llegó un paquete, otro visitante entra sin que yo vea quién es. Es imposible hacer todo al mismo tiempo.',
          name: 'Carlos A.',
          role: 'Portero — 11 años de profesión',
        },
        {
          quote: 'He perdido la cuenta de cuántas veces tuve que mediar peleas de vecinos por paquetes perdidos. Sin registro, sin foto. El portero jura que lo guardó, el vecino jura que no. Imposible resolver.',
          name: 'Marcela S.',
          role: 'Administradora hace 4 años, edificio de 180 aptos',
        },
        {
          quote: 'Llegué del viaje y mi paquete había desaparecido. El portero mostró el cuaderno — una letra imposible, fecha incorrecta. Así quedó: sin paquete, sin culpable, sin solución.',
          name: 'Rodrigo M.',
          role: 'Residente, piso 8, Montevideo',
        },
      ],
    },
    costSection: {
      badge: 'El costo que nadie calcula',
      title: '¿Cuánto cuesta por año una portería desorganizada?',
      subtitle: 'No es solo el estrés. Hay costos financieros, legales y de rotación que se ignoran hasta que se convierten en un problema mayor.',
      items: [
        { value: '$ 2.400', label: 'perdidos por año en retrabajo y llamadas innecesarias (estimación por portero)' },
        { value: '$ 800+', label: 'en promedio por incidente de extravío de paquete con proceso o acuerdo' },
        { value: '43%', label: 'más rotación en porterías que no tienen sistema de apoyo al portero' },
        { value: '18h', label: 'por mes que el administrador pasa resolviendo conflictos que un sistema evitaría' },
      ],
      timeline: {
        label: 'Un día típico en la portería sin sistema',
        events: [
          { time: '07h00', event: 'Turno comienza. 3 paquetes en el suelo sin identificación de la semana anterior.' },
          { time: '08h30', event: 'Vecino llama preguntando si llegó un paquete. El portero busca en el cuaderno por 5 minutos.' },
          { time: '09h15', event: 'Empresa de mudanza llega sin agendamiento. Ascensor bloqueado.' },
          { time: '10h00', event: 'Visitante insiste en entrar sin autorización. Portero llama al vecino — cae al buzón de voz.' },
          { time: '11h45', event: 'Vecina furiosa reclama que su paquete desapareció. Sin registro, sin foto.' },
          { time: '14h00', event: 'Administrador llega para apagar incendios. Pasa 2h resolviendo lo que no es su función.' },
          { time: '18h00', event: 'Turno terminado. Sin registro formal del día. Mañana empieza todo de nuevo.' },
        ],
      },
    },
    solution: {
      badge: 'La buena noticia',
      title: 'Todos estos problemas tienen solución.',
      titleAccent: 'Y más sencilla de lo que parece.',
      subtitle: 'CondoClick fue creado después de entrevistar a decenas de porteros y administradores. Cada funcionalidad resuelve un problema real — no es recurso de fachada.',
      ctaSee: 'Ver cómo funciona',
      ctaPlan: 'Crear mi plan',
    },
    cards: [
      {
        emoji: '📦',
        title: 'Paquetes sin control',
        badge: 'Criticidad ALTA',
        desc: 'La portería se convirtió en depósito. Cajas esparcidas por el suelo, sin identificación, sin foto, sin registro de cuándo llegaron. El vecino llama furioso — el portero no sabe nada. Cuando encuentra, ya tenía dos semanas ahí. Si desapareció, no hay prueba de nada.',
        items: [
          { emoji: '😤', text: 'El vecino llama repetidamente para saber si llegó' },
          { emoji: '🗂️', text: 'Cuaderno tachado, ilegible o simplemente desapareció' },
          { emoji: '😰', text: 'Sin foto = sin prueba en caso de extravío' },
        ],
      },
      {
        emoji: '📞',
        title: 'Portero: central de llamadas',
        badge: 'Criticidad ALTA',
        desc: '"Llegó paquete. Llegó visita. ¿Ya puedo subir? Tu auto está bloqueando." El portero pasa gran parte del turno al teléfono — en vez de cuidar la seguridad. Mientras tanto, ¿quién controla quién entra?',
        items: [
          { emoji: '📲', text: 'Promedio de 60 a 120 llamadas por turno en condominios medianos' },
          { emoji: '🚪', text: 'Control de acceso comprometido en horas pico' },
          { emoji: '😵', text: 'Portero agotado = más errores y menos atención' },
        ],
      },
      {
        emoji: '🚗',
        title: 'Acceso vehicular sin registro',
        badge: 'Riesgo de SEGURIDAD',
        desc: 'Uber, delivery, prestador de servicios, visitante — todo liberado de palabra. No hay registro de la patente, del horario, de qué unidad fue. Si pasa algo, no hay manera de saber quién entró. La seguridad del condominio depende de la memoria.',
        items: [
          { emoji: '❓', text: '¿Quién entró ayer a las 22h? Imposible saber' },
          { emoji: '🔓', text: 'Prestadores entran y salen sin rastro alguno' },
          { emoji: '📝', text: 'Libro de incidencias ilegible e incompleto' },
        ],
      },
      {
        emoji: '📅',
        title: 'Salón reservado dos veces',
        badge: 'Conflicto recurrente',
        desc: 'Dos vecinos reservaron el mismo día el salón. Uno por el grupo de WhatsApp, otro "le avisó al portero". Resultado: pelea, reunión de condominio, administrador mediando conflicto un viernes a la noche. Esto se repite cada mes en algún espacio del edificio.',
        items: [
          { emoji: '😡', text: 'Conflictos entre vecinos por doble reserva' },
          { emoji: '💬', text: 'Reservas hechas por grupo de WhatsApp sin control' },
          { emoji: '🤦', text: 'El administrador pasa horas mediando lo que sería evitable' },
        ],
      },
      {
        emoji: '🚛',
        title: 'Mudanza bloqueando el ascensor a las 7h',
        badge: 'Portería',
        desc: 'La empresa de mudanza llegó temprano, sin aviso, y tomó el ascensor social de mañana. Ningún otro vecino puede usarlo. El portero no sabe qué hacer. El administrador necesita ser contactado de urgencia — en sábado de descanso.',
        items: [
          { emoji: '🛗', text: 'Ascensor bloqueado por horas sin agendamiento' },
          { emoji: '📵', text: 'Administrador contactado en su celular personal el fin de semana' },
          { emoji: '🏗️', text: 'Sin registro del estado del ascensor antes/después' },
        ],
      },
      {
        emoji: '📢',
        title: 'Comunicados que nadie lee',
        badge: 'Comunicación',
        desc: 'El aviso de mantenimiento se pegó en el ascensor el lunes. El miércoles, la mitad de los vecinos reclamó que no sabía. El papel desapareció, el grupo de WhatsApp está silencioso, y nadie confirma que lo recibió. ¿Cómo probar que comunicó?',
        items: [
          { emoji: '🗒️', text: 'Avisos en papel que desaparecen o se rompen' },
          { emoji: '🔕', text: 'Grupo de WhatsApp con 200 mensajes no leídos' },
          { emoji: '📋', text: 'Sin confirmación de lectura = sin prueba legal' },
        ],
      },
      {
        emoji: '🔑',
        title: 'Administrador sin visibilidad de lo que ocurre',
        badge: 'Gestión',
        desc: 'El administrador solo se entera de los problemas cuando ya se convirtieron en conflicto. No hay datos, no hay informe, no hay historial. Cada decisión se toma a la intuición. La asamblea se acerca y no hay nada concreto para presentar.',
        items: [
          { emoji: '📊', text: 'Ningún dato para respaldar decisiones de gestión' },
          { emoji: '🕵️', text: 'Solo descubre el problema cuando ya es una crisis' },
          { emoji: '📑', text: 'Asamblea sin informe = administrador sin credibilidad' },
        ],
      },
    ],
  },

  // ── Para quién
  forWhom: {
    badge: '¿Para quién es CondoClick?',
    title: 'Hecho para quienes cuidan el condominio',
    subtitle: 'Administrador, empresa de gestión, vecino o repartidor — cada perfil tiene lo que necesita, en el mismo sistema.',
    profiles: [
      {
        role: 'Administrador',
        title: 'Control total, menos estrés',
        desc: 'Usted sabe lo que pasa en la portería en tiempo real — incluso desde casa, incluso el fin de semana. Se acabó que lo llamen al celular por problemas que un sistema resolvería solo.',
      },
      {
        role: 'Empresa de Gestión',
        title: 'Varios condominios, una sola plataforma',
        desc: 'Gestione múltiples edificios en un único lugar. Cada condominio con ambiente aislado y enlace exclusivo — sin mezclar datos, sin abrir mil pestañas.',
      },
      {
        role: 'Residente',
        title: 'Avisado a tiempo, sin depender de nadie',
        desc: '¿Llegó su paquete? Recibe foto y aviso en WhatsApp en el mismo momento. ¿Quiere retirar? Solo muestre el QR Code. Sin llamar a portería, sin esperar en fila.',
      },
      {
        role: 'Repartidor',
        title: 'Solo escanear y entregar',
        desc: 'Un QR Code fijo en el vidrio de la portería. El repartidor escanea con su propio celular, saca la foto y se va. Sin esperar al portero, sin formulario, sin complicaciones.',
      },
    ],
  },

  // ── Producto / Showcase
  product: {
    badge: 'Vea el producto',
    title: 'Un sistema para cada perfil',
    subtitle: 'Del portero al vecino — todos ganan con CondoClick.',
    tabs: {
      porteiro: '👮 Portero',
      morador: '🏠 Vecino',
      sindico: '📊 Administrador',
      entregador: '📦 Repartidor',
    },
    porteiro: {
      title: 'Registrar paquete en 30 segundos',
      desc: 'El portero abre la app en el celular, fotografía el paquete, selecciona la unidad y hace clic en registrar. El WhatsApp del vecino recibe la notificación en el mismo momento.',
      features: ['Foto automática del paquete', 'Búsqueda rápida por unidad o nombre', 'QR Code generado en el momento', 'WhatsApp enviado automáticamente'],
    },
    morador: {
      title: 'Vecino avisado a tiempo',
      desc: 'Tan pronto el portero registra, el vecino recibe un WhatsApp con foto, detalles y un QR Code exclusivo. Al retirar, solo muestre el código en portería.',
      features: ['Notificación instantánea en WhatsApp', 'Foto del paquete en el mensaje', 'QR Code para retiro rápido', 'Historial de todas las entregas'],
    },
    entregador: {
      badge: 'Nuevo — Auto-registro por QR Code',
      title: 'Repartidor registra solo, sin portero',
      desc1: 'Coloque un QR Code fijo en el vidrio de la portería o en un cartel en la entrada. El repartidor de cualquier empresa escanea con su propio celular, saca la foto y registra la entrega — todo sin necesitar llamar al portero.',
      desc2: 'El vecino recibe la notificación en WhatsApp en el mismo momento. Portería más ágil, cero filas y ningún paquete olvidado en la acera.',
      features: [
        'QR Code fijo pegado en el vidrio o cartel',
        'Repartidor escanea con cualquier celular',
        'Saca foto e informa el volumen',
        'Vecino recibe WhatsApp instantáneo',
        'Cero dependencia del portero',
        'El QR Code de portería funciona incluso sin internet',
      ],
      plaqueLabel: 'Registre su entrega aquí',
      plaqueSub: 'Escanee con cualquier celular',
      plaqueStickerLabel: 'Cartel impreso o adhesivo en el vidrio de la portería',
    },
    sindico: {
      title: 'Administrador siempre en control',
      desc: 'Panel con informes, historial completo de entregas, gestión de vecinos y estado en tiempo real de todo lo que pasa por la portería.',
      features: ['Panel con métricas en tiempo real', 'Informes mensuales automáticos', 'Gestión de vecinos y unidades', 'Auditoría completa de todas las entregas'],
    },
  },

  // ── Módulos
  modules: {
    badge: 'Módulos',
    title: 'Un sistema, seis módulos',
    subtitle: 'Active los que necesita. Cada módulo funciona de forma independiente y se integra con los demás.',
    prevBtn: 'Anterior',
    nextBtn: 'Siguiente',
    activeLabel: 'Activo ahora',
    qrLabel: 'QR Code generado',
    qrSub: 'Todo funciona sin conexión',
    crosscutting: [
      { title: 'Todo por QR Code', description: 'QR Codes únicos por evento — visita, paquete, reserva o mudanza.' },
      { title: 'WhatsApp nativo', description: 'Notificaciones automáticas por WhatsApp, sin instalar nada.' },
      { title: '100% Móvil', description: 'Portero, vecino y administrador acceden desde el celular, en el navegador.' },
      { title: 'Informes en vivo', description: 'Panel e informes completos para el administrador siempre en control.' },
    ],
    list: [
      {
        badge: 'Módulo Portería', title: 'Paquetes & Entregas',
        desc: 'El portero registra, el vecino es notificado en WhatsApp y retira con QR Code. Sin papel, sin llamadas, sin paquete perdido.',
        features: ['Registro con foto obligatoria', 'QR Code exclusivo por paquete', 'Notificación vía WhatsApp', 'Modo privado para envíos sensibles', 'Historial completo de retiros'],
      },
      {
        badge: 'Módulo Vehículos', title: 'Control de Vehículos',
        desc: 'Sepa exactamente quién entró, cuándo salió y a qué unidad fue. Uber, delivery, prestadores y visitantes — todo categorizado.',
        features: ['10 categorías predefinidas', 'Registro de patente y foto', 'Control de entrada y salida', 'Panel en vivo para el administrador', 'Historial completo por unidad'],
      },
      {
        badge: 'Módulo Visitas', title: 'Gestión de Visitantes',
        desc: 'El portero registra al visitante, el vecino autoriza por WhatsApp y el visitante recibe QR Code. Acceso liberado sin una sola llamada.',
        features: ['Aprobación del vecino vía WhatsApp', 'QR Code enviado al visitante', 'Portero escanea en la entrada', 'Frecuencia configurable', 'Foto y documento del visitante'],
      },
      {
        badge: 'Módulo Reservas', title: 'Espacios Comunes',
        desc: 'Se acabaron las planillas y WhatsApp para reservar el salón. El vecino reserva desde el celular, confirma con QR Code y el espacio queda bloqueado automáticamente.',
        features: ['Calendario de disponibilidad', 'Reserva desde el celular sin app', 'QR Code de acceso al espacio', 'Cancelación sin burocracia', 'Informe de uso por espacio'],
      },
      {
        badge: 'Módulo Mudanzas', title: 'Agendamiento de Mudanzas',
        desc: 'Los vecinos agendan la mudanza, el administrador aprueba y la empresa de mudanza recibe QR Code. Ascensor social protegido y mudanza registrada de principio a fin.',
        features: ['Agendamiento con aprobación del administrador', 'QR Code para la empresa de mudanza', 'Control de horario del ascensor', 'Notificación a demás vecinos', 'Registro fotográfico de condición'],
      },
      {
        badge: 'Módulo Comunicados', title: 'Alertas & Comunicados',
        desc: 'Envíe comunicados, alertas de emergencia y documentos a todos los vecinos por WhatsApp — con confirmación de lectura.',
        features: ['Avisos vía WhatsApp y app', 'Alertas de emergencia inmediatas', 'Duplicado de recibo y documentos', 'Confirmación de lectura', 'Filtro por unidad o grupo'],
      },
    ],
  },

  // ── QR Code flows
  qrFlows: {
    badge: 'Cómo funciona en la práctica',
    title: 'Simple para quien lo usa. Poderoso para quien gestiona.',
    subtitle: 'Cada módulo tiene un flujo directo — sin papel, sin llamadas, sin retrabajo. Todo rastreado y confirmado automáticamente.',
    flows: [
      {
        title: '📦 Paquetes',
        desc: 'El portero registra con foto. El residente recibe el QR Code en WhatsApp. El retiro escanea y confirma — todo en segundos. El síndico tiene comprobante de cada entrega, sin pedirlo.',
        steps: ['Portero registra + foto', 'QR Code generado', 'Residente recibe en WhatsApp', 'Presenta en portería', 'Entrega confirmada ✅'],
      },
      {
        title: '🚪 Portería',
        desc: 'El residente autoriza desde el celular antes de que llegue la visita. El visitante recibe el QR Code. El portero solo escanea — sin llamar, sin papel. El portero lo agradece. El residente también.',
        steps: ['Residente registra la visita', 'Aprueba desde el celular', 'Visita recibe QR', 'Portero escanea', 'Acceso liberado ✅'],
      },
      {
        title: '🚗 Control de Vehículos',
        desc: 'Uber, delivery, proveedor, visitante — todo categorizado con placa y foto. Entrada y salida registradas. El síndico monitorea en vivo. Si un vehículo supera el tiempo permitido, el sistema avisa automáticamente.',
        steps: ['Vehículo llega', 'Portero registra placa + categoría', 'Foto capturada', 'Salida confirmada', 'Historial registrado ✅'],
      },
      {
        title: '🏊 Reservas de Espacios',
        desc: 'El residente reserva el salón, parrillero o gimnasio desde el celular. Conflicto de fecha bloqueado automáticamente. QR Code de acceso enviado.',
        steps: ['Residente elige fecha', 'Sistema verifica disponibilidad', 'Reserva confirmada', 'QR Code enviado', 'Uso registrado ✅'],
      },
      {
        title: '📖 Libro de Ocurrencias',
        desc: 'Fin del libro físico. El portero o residente registra desde el celular. El administrador responde. Todo archivado con fecha, hora y autoría.',
        steps: ['Ocurrencia registrada', 'Foto o documento adjunto', 'Administrador notificado', 'Respuesta registrada', 'Archivado ✅'],
      },
      {
        title: '📣 Comunicados',
        desc: 'Aviso de mantenimiento, alerta de emergencia o recordatorio de pago — enviado en WhatsApp a todos los residentes con confirmación de lectura.',
        steps: ['Síndico crea el comunicado', 'Selecciona destinatarios', 'WhatsApp enviado', 'Lectura confirmada', 'Archivado ✅'],
      },
      {
        title: '🚨 Botón de Pánico',
        desc: 'Cuando la situación no puede esperar, un toque en el celular dispara una alerta inmediata al síndico vía WhatsApp. Sin llamadas, sin demora.',
        steps: ['Portero activa el botón', 'Alerta disparada en < 1s', 'Síndico notificado en WhatsApp', 'Ocurrencia registrada automáticamente', 'Situación documentada ✅'],
      },
    ],
    banner: 'Cada acción registrada. Cada evento rastreado.',
    bannerSub: 'Del portero al síndico — todos saben qué pasó, cuándo y quién lo hizo.',
  },

  // ── Tipos de condominio
  condoTypes: {
    badge: 'Cualquier formato',
    title: '¿Sirve para su condominio?',
    subtitle: 'Sí — independientemente del tamaño o formato. CondoClick se adapta a la estructura real de su condominio, no al revés.',
    types: [
      { title: 'Condominio de Casas', desc: 'Calles, villas y loteos cerrados. Cada casa es una unidad — simple así.' },
      { title: 'Torre Única', desc: 'Pisos y apartamentos configurados exactamente como están numerados en su edificio.' },
      { title: 'Multi-Torres', desc: 'Torre A, B, C... Grandes emprendimientos con cada torre y sus unidades organizadas y separadas.' },
      { title: 'Edificio Comercial', desc: 'Oficinas, salas y pisos comerciales. Control de acceso, visitas y paquetes para síndicos de edificios corporativos.' },
    ],
    customTitle: '100% personalizable',
    customDesc: 'La primera vez que accede, un asistente guiado configura la estructura completa de su condominio — torres, pisos y unidades — exactamente como existe. Sin formularios complicados, sin planilla para importar.',
  },

  // ── Cómo funciona
  howItWorks: {
    badge: 'Paso a paso',
    title: 'Comience en 4 pasos simples',
    subtitle: 'Del registro a la primera entrega registrada en menos de 2 minutos.',
    steps: [
      { title: 'Elija el plan', description: 'Seleccione el plan, pague con tarjeta y acceda de inmediato' },
      { title: 'Configure', description: 'Registre torres, unidades y vecinos en el panel admin' },
      { title: 'Registre', description: 'El portero fotografía y registra cada entrega con QR Code' },
      { title: 'Retire', description: 'El vecino presenta el QR Code y retira — todo registrado' },
    ],
    stepLabel: 'Paso',
  },

  // ── Testimonios
  testimonials: {
    badge: 'Testimonios',
    title: 'Quien lo usa, lo aprueba',
    rating: '4.9/5',
    reviews: '312 valoraciones',
    items: [
      { name: 'Andrés Méndez', role: 'Administrador — Edificio Aurora', text: 'Antes perdíamos horas con el cuaderno de paquetes. Ahora el portero registra en segundos y el vecino ya recibe el WhatsApp. ¡Excelente!' },
      { name: 'Patricia Lima', role: 'Gestora — Condominio Blue Tree', text: 'El sistema es muy intuitivo. Lo implementamos en dos condominios y los vecinos adoraron la notificación por WhatsApp cuando llega el paquete.' },
      { name: 'Roberto Suárez', role: 'Portero — Residencial Park', text: 'Muy fácil de usar. Antes anotaba todo en papel y siempre había quejas. Ahora solo hay que fotografiar y registrar. No me imagino sin este sistema.' },
    ],
  },

  // ── Planes
  plans: {
    trialBadge: '🎉 7 días gratis · sin cobro hoy · cancele cuando quiera',
    badge: 'Planes',
    title: 'Precio transparente, sin sorpresas',
    subtitle: 'Active solo lo que necesita. Agregue o quite módulos en cualquier momento.',
    monthly: 'Mensual',
    annual: 'Anual',
    annualDiscount: '−20%',
    annualSavings: '$ {{yearly}}/año · ahorra $ {{savings}}/año',
    freeTrial: '🎉 Primeros 7 días totalmente gratis',
    ctaBtn: 'Comenzar 7 días gratis →',
    items: [
      {
        id: 'encomendas', name: 'Paquetería', priceMonthly: 24, pricePerUnit: 0.50,
        desc: 'Controle completo de paquetes: registro con foto y aviso automático al vecino por WhatsApp.',
        features: ['Chatbot 24h en WhatsApp', 'Registro de paquetes con foto', 'Aviso automático al vecino vía WhatsApp', 'QR Code de retiro', 'Reporte de pendientes', '3 meses de historial', 'Panel del administrador incluido', 'Soporte vía WhatsApp'],
        badge: null, highlight: false,
      },
      {
        id: 'pro', name: 'Portería Inteligente', priceMonthly: 49, pricePerUnit: 1.00,
        desc: 'Control total de quién entra y sale: paquetes, vehículos y visitantes — todo registrado y rastreado.',
        features: ['Todo de Paquetería', 'Chatbot 24h en WhatsApp', 'Control de acceso de vehículos', 'Autorización de visitantes por WhatsApp', 'QR Code de acceso para visitantes', '6 meses de historial'],
        badge: '⭐ Más popular', highlight: true,
      },
      {
        id: 'enterprise', name: 'Condominio Autónomo', priceMonthly: 74, pricePerUnit: 1.50,
        desc: 'Gestión completa del condominio: portería, libro de incidencias, reservas y comunicados — todo en un solo lugar.',
        features: ['Todo de Portería Inteligente', 'Chatbot 24h en WhatsApp', 'Libro de incidencias digital', 'Reservas de áreas comunes', 'Comunicados y alertas', 'Agenda de mudanzas', '1 año de historial'],
        badge: '🏆 Gestión Completa', highlight: false,
      },
    ],
    coupon: {
      title: 'Gane 10% de descuento extra',
      desc: 'Ingrese su correo y reciba un cupón exclusivo para usar en el checkout.',
      placeholder: 'su@correo.com',
      btn: 'Quiero el cupón',
      loadingBtn: '...',
      successTitle: '¡Su cupón está listo!',
      successDesc: 'Úselo en el checkout para obtener 10% de descuento adicional sobre el plan.',
      copyBtn: 'Copiar',
    },
    trust: [
      'Sin permanencia', 'Cancele cuando quiera', 'Soporte vía WhatsApp', 'Datos seguros en la nube',
    ],
    securePayment: 'Pago 100% seguro',
    secureNote: 'Sus datos de pago son cifrados y procesados con seguridad. Nunca almacenamos datos de su tarjeta.',
    toastEmailError: 'Correo inválido',
    toastCouponSuccess: '¡Cupón generado! Úselo en el checkout.',
    toastCouponCopied: '¡Cupón copiado!',
  },

  // ── Funcionalidades detalladas
  features: {
    badge: 'Funcionalidades',
    title: 'Cada detalle pensado para su rutina',
    subtitle: 'Entienda cómo funciona cada módulo en la práctica — del registro a la confirmación, todo automatizado y rastreado.',
    visit: {
      badge: 'WhatsApp + QR Code',
      title: 'Autorización de Visita sin llamadas, sin papel',
      desc: 'El portero informa quién llegó. El vecino autoriza (o deniega) por WhatsApp. El visitante recibe el QR Code en el momento. Todo rastreado y archivado.',
      steps: [
        { label: 'Portero registra al visitante', desc: 'Nombre, documento, foto y unidad de destino — en segundos desde la app.' },
        { label: 'Vecino recibe enlace en WhatsApp', desc: 'Ve los datos del visitante y hace clic en Autorizar o Denegar — sin descargar nada.' },
        { label: 'QR Code generado automáticamente', desc: 'El visitante presenta el código en portería. El portero escanea y el acceso es liberado y registrado.' },
      ],
      tags: ['Historial de accesos', 'Frecuencia configurable', 'Soporte para prestadores de servicios', 'Foto del visitante'],
      accessGranted: 'Acceso liberado',
    },
    vehicle: {
      badge: 'Control de Vehículos',
      title: 'Sepa exactamente quién entró — y quién aún está adentro',
      desc: 'Registro por categoría con patente, foto y unidad de destino. El portero registra a la entrada, confirma a la salida. El administrador monitorea en tiempo real.',
      categories: [
        { icon: '🚗', label: 'Apps de transporte', desc: 'Uber, Cabify, inDriver' },
        { icon: '📦', label: 'Delivery', desc: 'PedidosYa, Rappi, Correo, Amazon' },
        { icon: '🔧', label: 'Prestadores de servicio', desc: 'Plomero, Electricista, Pintores' },
        { icon: '📡', label: 'Empresas de servicios', desc: 'Antel, UTE, OSE, Movistar' },
        { icon: '📦', label: 'Mudanzas', desc: 'Con agendamiento y control' },
        { icon: '👤', label: 'Visitantes', desc: 'Vinculados a la unidad de destino' },
      ],
    },
    parcel: {
      badge: 'Paquetes',
      title: 'Ningún paquete desaparece ni queda olvidado',
      desc: 'El portero fotografía y registra el paquete en segundos. El vecino recibe aviso en WhatsApp en el momento. El retiro se confirma por QR Code o firma digital.',
      steps: [
        { label: 'Portero fotografía y registra', desc: 'Remitente, código de rastreo y unidad destino capturados en tiempo real.' },
        { label: 'Vecino notificado por WhatsApp', desc: 'Mensaje automático con foto del paquete y código de retiro.' },
        { label: 'Retiro confirmado por QR Code', desc: 'El vecino presenta el QR Code y el portero escanea. Registro de quién retiró y cuándo.' },
      ],
      privacyTitle: 'Modo privacidad para envíos sensibles',
      privacyDesc: 'Marque un paquete como privado y solo el destinatario puede ver el contenido — ni otros vecinos, ni el portero.',
    },
    doormen: {
      title: 'Porteros por Torre',
      desc: 'Registre cada portero, defina en qué torres actúa y controle quién está activo. Cada operación queda vinculada al portero responsable.',
      features: ['Múltiples porteros', 'Asignación por torre', 'Historial por operador', 'Activar / desactivar'],
    },
    residentApp: {
      title: 'App del Vecino',
      desc: 'Sin descarga. El vecino accede desde el navegador: ve paquetes pendientes con foto, autoriza visitas y muestra el QR Code en portería.',
      features: ['Acceso sin instalar nada', 'QR Code para retirar paquetes', 'Visitas solicitadas y aprobadas', 'Notificaciones en tiempo real'],
    },
    notifications: {
      title: 'Notificaciones Automáticas',
      desc: '¿Llegó un paquete? ¿Visita autorizada? ¿Reserva confirmada? El vecino recibe en WhatsApp — sin intervención manual de portería.',
      features: ['Mensajes vía WhatsApp', 'Recordatorios automáticos', 'Badge de no leídos', 'Historial de notificaciones'],
    },
    ctaBanner: '¿Listo para eliminar el papel de su portería?',
    ctaBannerSub: 'Más de 500 condominios ya digitalizaron la portería con CondoClick. Configuración en menos de 2 minutos.',
    ctaBannerBtn: 'Crear mi plan ahora',
  },

  // ── FAQ
  faq: {
    badge: 'Preguntas',
    title: 'Preguntas frecuentes',
    items: [
      { question: '¿Necesito instalar alguna aplicación?', answer: 'No. CondoClick funciona 100% desde el navegador del celular. El portero accede desde el celular y el vecino también, sin necesidad de descargar nada.' },
      { question: '¿Cómo se notifica al vecino?', answer: 'Tan pronto el portero registra el paquete, el vecino recibe un mensaje automático vía WhatsApp con foto, detalles de la entrega y el QR Code para el retiro.' },
      { question: '¿Puedo cancelar cuando quiera?', answer: 'Sí. No hay permanencia. Puede cancelar su suscripción en cualquier momento, sin multas ni burocracia. El acceso permanece activo hasta el final del período pagado.' },
      { question: '¿Funciona para condominios grandes?', answer: 'Sí. Tenemos planes para condominios de todos los tamaños, desde pequeños edificios hasta grandes complejos con múltiples torres y cientos de unidades.' },
      { question: '¿Los datos son seguros?', answer: 'Sí. Todos los datos se almacenan en la nube con cifrado AES-256 y backup automático diario. Utilizamos infraestructura de nivel empresarial.' },
      { question: '¿Cuánto tiempo lleva configurar?', answer: 'Aproximadamente 2 minutos para crear el condominio y registrar el primer portero. El registro de unidades y vecinos puede hacerse gradualmente.' },
      { question: '¿Cómo funciona el módulo de visitas?', answer: 'El vecino accede a la app, registra el nombre de la visita y la fecha. Con un toque, aprueba y el visitante recibe automáticamente un QR Code vía WhatsApp. En portería, el portero escanea el QR Code y el acceso es liberado y registrado — sin llamadas, sin papel.' },
      { question: '¿Necesito activar todos los módulos?', answer: 'No. Cada condominio elige qué módulos activar. Puede comenzar con paquetes y vehículos, por ejemplo, y agregar reservas y mudanzas cuando quiera. Cada módulo es independiente y no interfiere con los demás.' },
    ],
  },

  // ── CTA Final
  ctaFinal: {
    badge: 'Más de 500 condominios confían en CondoClick',
    title: 'Comience ahora mismo.',
    titleAccent: 'Configure en menos de 2 minutos.',
    subtitle: 'Sin permanencia. Sin complicaciones. Pague con tarjeta de crédito y comience a usar de inmediato.',
    offer: '🔥 30% OFF en los 3 primeros meses — oferta por tiempo limitado',
    btn: 'Suscribirse ahora con tarjeta de crédito',
    note: 'Pago seguro · Datos cifrados · Cancele cuando quiera',
  },

  // ── Footer
  footer: {
    tagline: 'La portería inteligente para condominios modernos. Simple para el portero, tranquilo para el vecino, poderoso para el administrador.',
    product: 'Producto',
    forWhom: 'Para quién',
    company: 'Empresa',
    links: {
      howItWorks: 'Cómo funciona',
      modules: 'Módulos',
      plans: 'Planes y precios',
      whyCondoClick: '¿Por qué CondoClick?',
      syndics: 'Para Administradores',
      managers: 'Para Empresas de Gestión',
      franchise: 'Sea un Franquiciado',
      about: 'Sobre Nosotros',
      contact: 'Contáctenos',
      support: 'Soporte Técnico',
      blog: 'Blog & Artículos',
    },
    copyright: '© {{year}} CondoClick — Todos los derechos reservados',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Uso',
  },

  // ── Blog destacado (landing page)
  blogTeaser: {
    badge: 'Nuestro blog',
    title: 'Aprende antes de decidir',
    subtitle: 'Guías prácticas para síndicos, administradores y gestores de condominio.',
    allArticles: 'Ver todos los artículos',
    readMore: 'Leer artículo',
    featured: [
      {
        slug: 'como-controlar-paquetes-condominio',
        icon: '📦',
        category: 'Portería & Seguridad',
        title: 'Cómo controlar paquetes en condominio',
        excerpt: 'Paquetes apilados en portería, residentes reclamando por encomiendas perdidas. Descubre cómo crear un proceso eficiente que elimina conflictos.',
        readingTime: 6,
      },
      {
        slug: 'el-caos-de-los-paquetes-en-porteria',
        icon: '🚨',
        category: 'Caos en la Portería',
        title: 'El caos de los paquetes en portería',
        excerpt: 'Era lunes por la mañana. El portero encontró 23 cajas apiladas, ninguna identificada, y tres WhatsApps furiosos de residentes esperando.',
        readingTime: 5,
      },
      {
        slug: 'como-autorizar-visitas-whatsapp',
        icon: '💬',
        category: 'Control de Acceso',
        title: 'Cómo autorizar visitas por WhatsApp',
        excerpt: 'Autorizar una visita no debería tomar más de 30 segundos. Descubre cómo WhatsApp puede transformar el control de acceso de tu condominio.',
        readingTime: 5,
      },
    ],
  },

  // ── Barra móvil inferior
  // ── Checkout flow
  checkout: {
    backToPlans: 'Volver a los planes',
    back: 'Volver',
    selectedPlan: 'Plan seleccionado',
    trialBadge: '🎉 7 días gratis · sin cobro hoy',
    perMonthAfterTrial: '/ mes después del período gratis',
    moreFeatures: 'funciones',
    summaryTitle: 'Resumen',
    sslBadge: 'Cifrado SSL de extremo a extremo',
    labelCondo: 'Condominio',
    labelUrl: 'URL',
    labelResponsible: 'Responsable',
    labelEmail: 'E-mail',
    labelCity: 'Ciudad',
    labelPlan: 'Plan',
    stepOf: 'Paso {{step}} de 4',
    steps: ['Condominio', 'Responsable', 'Dirección', 'Revisión'] as unknown as string[],
    condoNameLabel: 'Nombre del condominio',
    condoNamePlaceholder: 'Ej: Residencial las Flores',
    condoNameLabelMulti: 'Nombre del complejo',
    condoNamePlaceholderMulti: 'Ej: Condominio Las Flores',
    subdomainLabel: 'Subdominio (dirección de tu condominio)',
    subdomainPlaceholder: 'flores',
    subdomainHint: 'Los vecinos accederán en:',
    condoTypeLabel: 'Tipo de condominio',
    condoTypes: {
      houses:       { label: 'Casas / Lotes',      desc: 'Condominio horizontal, sin torres' },
      single_tower: { label: 'Torre Única',         desc: 'Un único edificio con apartamentos' },
      multi_tower:  { label: 'Múltiples Torres',    desc: 'Dos o más edificios/bloques' },
    },
    condoPurposeLabel: 'Finalidad',
    condoPurposes: {
      residential:  { label: 'Residencial',  desc: 'Apartamentos, casas y lotes para vivienda' },
      commercial:   { label: 'Comercial',    desc: 'Oficinas, locales y espacios empresariales' },
      association:  { label: 'Asociación',   desc: 'Club, asociación o entidad sin fines de lucro' },
    },
    towerConfigLabel: 'Configure las torres / bloques',
    towerPrefixLabel: '¿Cómo llamar cada división?',
    towerPrefixTorre: 'Torre',
    towerPrefixBloco: 'Bloque',
    towerCountLabel: '¿Cuántas torres / bloques?',
    towerPreviewLabel: 'Se crearán automáticamente:',
    towerPreviewHint: 'Podrás renombrar cada torre desde el panel administrativo.',
    unitsLabel: 'Cantidad de unidades',
    unitsSuffix: 'unidades',
    unitsIncluded: 'incluye {{n}} unidades en el plan',
    unitsExtra: 'unidades extras',
    unitsTotal: 'Total con {{n}} unidades',
    unitsPerUnitCost: '{{price}}/unidad extra/mes',
    unitsReduceNote: 'El plan cubre hasta {{n}} unidades.',
    unitsUpgradeNote: 'Unidades sobre {{n}} tendrán costo adicional.',
    labelUnits: 'Unidades',
    labelExtraUnits: 'Unidades extras',
    labelTotal: 'Total',
    fullNameLabel: 'Nombre completo',
    fullNamePlaceholder: 'Nombre del responsable',
    personTypeLabel: 'Tipo de persona',
    personIndividual: 'Persona Física',
    personCompany: 'Persona Jurídica',
    docIndividualLabel: 'RUT / Cédula / DNI',
    docCompanyLabel: 'RUT Empresa',
    docIndividualPlaceholder: 'Documento de identidad',
    docCompanyPlaceholder: 'RUT Empresa',
    phoneLabel: 'Teléfono',
    phonePlaceholder: '+598 99 123 456',
    passwordDivider: 'Contraseña de acceso admin',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: 'Mín. 6 caracteres',
    confirmPasswordLabel: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Repita la contraseña',
    passwordHint: 'Esta contraseña se usará para acceder al panel administrativo.',
    postalCodeLabel: 'Código Postal',
    streetLabel: 'Calle',
    streetPlaceholder: 'Nombre de la calle',
    numberLabel: 'Número',
    numberPlaceholder: 'Nº',
    complementLabel: 'Complemento',
    complementPlaceholder: '(opcional)',
    neighborhoodLabel: 'Colonia / Barrio',
    cityLabel: 'Ciudad',
    stateLabel: 'Estado / Depto.',
    chargedAfter: 'Cobrado después de 30 días',
    todayPays: 'Hoy pagas',
    trialActivationTitle: 'Activación inmediata — sin tarjeta',
    trialActivationDesc: 'Tu condominio será creado y activado al instante. Recibirás los datos de acceso por e-mail.',
    payTitle: 'Pago via InfinitePay',
    payDesc: 'Serás redireccionado al checkout seguro de InfinitePay. Aceptamos tarjeta de crédito y PIX.',
    termsNote: 'Al suscribirse, acepta los Términos de Servicio y Política de Privacidad.',
    continue: 'Continuar',
    submitTrial: 'Iniciar prueba gratuita',
    submittingTrial: 'Creando tu condominio...',
    submitPay: 'Pagar con InfinitePay',
    submittingPay: 'Generando link de pago...',
    secure: 'Conexión segura',
    encrypted: 'Datos cifrados',
    planLabel: 'Plan {{name}}',
    perMonth: '/mes',
    errCondoName: 'Ingrese el nombre del condominio',
    errSlugMin: 'El subdominio debe tener mínimo 3 caracteres',
    errCondoPurpose: 'Seleccione la finalidad del condominio',
    errCondoType: 'Seleccione el tipo de condominio',
    errAdminName: 'Ingrese el nombre del responsable',
    errEmail: 'E-mail inválido',
    errDocIndividual: 'Documento inválido',
    errDocCompany: 'Documento inválido',
    errPhone: 'Teléfono inválido',
    errPasswordMin: 'La contraseña debe tener mínimo 6 caracteres',
    errPasswordMatch: 'Las contraseñas no coinciden',
    errPostalCode: 'Ingrese el código postal',
    errStreet: 'Ingrese la calle manualmente',
    errSlugTaken: 'El subdominio ya está en uso. Elija otro.',
    errGeneric: 'Error en el checkout',
    toastCreated: '¡Condominio creado con éxito! 🎉',
    toastRedirecting: 'Redireccionando al pago...',
    emailSentTitle: 'Revisa tu e-mail 📧',
    emailSentDesc: 'Enviamos un enlace de confirmación a <strong>{{email}}</strong>. Haz clic en el enlace para completar el registro.',
    emailSentCheck: 'Revisa tu bandeja de entrada (y spam)',
    emailResendBtn: 'Reenviar e-mail',
    emailResending: 'Enviando...',
    emailResent: '¡E-mail reenviado con éxito!',
    emailSentExpire: 'El enlace expira en 24 horas.',
    emailSentBack: 'Modificar datos',
    toastEmailSent: '¡E-mail de confirmación enviado! Revisa tu bandeja de entrada.',
  },

  mobileBar: {
    from: 'Desde',
    price: '{{symbol}} 89',
    perMonth: '/mes',
    btn: 'Suscribirse ahora',
  },

  // ── Catálogo de módulos (wizard)
  modulesCatalog: [
    { id: 'encomendas', label: 'Paquetes & Entregas', desc: 'Registro con foto, notificación WhatsApp y retiro por QR Code' },
    { id: 'veiculos', label: 'Control de Vehículos', desc: 'Registro de patentes, visitantes, Uber, delivery y prestadores' },
    { id: 'visitantes', label: 'Gestión de Visitantes', desc: 'Autorización del vecino vía WhatsApp + QR Code de acceso' },
    { id: 'reservas', label: 'Reservas de Espacios', desc: 'Salón, parrilla, piscina — reserva desde el celular' },
    { id: 'mudancas', label: 'Agendamiento de Mudanzas', desc: 'Aprobación del administrador, QR Code para empresa de mudanza' },
    { id: 'comunicados', label: 'Comunicados & Alertas', desc: 'Avisos y documentos para vecinos vía WhatsApp' },
    { id: 'entregador', label: 'Auto-registro de Repartidor', desc: 'QR Code fijo en portería — repartidor registra solo' },
  ],
};

export default esUY;
